import { render } from "./SettingsView.vue?vue&type=template&id=1b0a163c&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"

import "./SettingsView.vue?vue&type=style&index=0&id=1b0a163c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0a163c"]])

export default __exports__